import * as React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import moment from 'moment'
import * as _ from 'lodash'

import IosCallOutline from 'react-ionicons/lib/IosCallOutline'
import IosCashOutline from 'react-ionicons/lib/IosCashOutline'

import { durationToDDHHMMSSMS, ContactHistoryT } from './ContactTab';
import { contactDate, styles, yourContact } from './style';
import { css } from 'glamor';
import { formatDate, sanitizeNumeric, stringLitArray } from '../../../../utils/utilsT';
import { JobStatusT, JobT } from '../../../../types/Job';
import config from '../../../../constants/config';
import AnnotationPhone, { PhoneAnnotationObject, PhoneAnnotationT } from './AnnotationPhone'
import { Button, Stack } from '@mui/material'
import { AxiosInstance } from '../../../../utils/RequestMethods'
import ButtonLoading from '../../../../components/ButtonLoading'


export interface IContactPhoneProps {
    job: JobT
    item: ContactHistoryT
    disputeEdit?: boolean
    displayMode?: "edit" | "view"
}


interface CallDateTimeT {
    date: Date
    timezone_type: number
    timezone: string
}


// Used for Dispute and Sales Call Annotations
interface ICallAnnotation {
    startTime: number
    endTime: number
    title: string
    summary: string
}


const CallStatusT = stringLitArray(['ringing', 'queued', 'in-progress', 'completed', 'answered', 'busy', 'no-answer', 'failed', 'canceled']);
export type CallStatusTStrings = (typeof CallStatusT)[number];
interface MetaPhoneT {

    from: string
    to: string
    called: string
    caller: string
    callStatus: CallStatusTStrings | null,
    dialCallStatus: string //['completed', 'answered', 'busy', 'no-answer', 'failed', 'canceled'];
    direction: string
    recordingSource: string

    recordingUrl: string
    recordingStatus: string
    recordingChannels: string
    recordingStartTime: string
    recordingDuration: number | string
    recordingUrlCopy: string
    startTime: CallDateTimeT | null
    endTime: CallDateTimeT | null
    callDirection: string
    transcriptionType: string
    transcriptionText: string
    transcriptionStatus: string

}
const initMeta: MetaPhoneT = {

    from: "",
    to: "",
    called: "",
    caller: "",
    callStatus: null,//['ringing','queued','in-progress','completed', 'answered', 'busy', 'no-answer', 'failed', 'canceled'];
    dialCallStatus: "",//['completed', 'answered', 'busy', 'no-answer', 'failed', 'canceled'];
    direction: "",
    recordingSource: "",
    // recordingSid: "",
    recordingUrl: "",
    recordingStatus: "",
    recordingChannels: "",
    recordingStartTime: "",
    recordingDuration: 0,
    recordingUrlCopy: "",
    startTime: null,
    endTime: null,
    callDirection: "",
    transcriptionType: "",
    transcriptionText: "",
    transcriptionStatus: "",

}
const ContactPhone: React.FC<IContactPhoneProps> = ({ job, item, disputeEdit, displayMode }) => {
    const [meta, setMeta] = React.useState(initMeta)
    const [isReady, setIsReady] = React.useState(false);

    const [annotations, setAnnotations] = React.useState<Array<PhoneAnnotationT>>([])

    React.useEffect(() => {
        setIsReady(true)
    }, [])
    React.useEffect(() => {
        if (!_.isEmpty(item.meta)) {
            setMeta({ ...initMeta, ...item.meta })
        }
    }, [item])


    React.useEffect(() => {
        parseDisputeNotes()
    }, [])



    // Call not picked up

    // const toHHMMSSs = (duration) => {
    //     const hours = moment.utc(moment.duration(duration, "seconds").asMilliseconds()).format("HH")
    //     const minutes = moment.utc(moment.duration(duration, "seconds").asMilliseconds()).format("mm")
    //     const seconds = moment.utc(moment.duration(duration, "seconds").asMilliseconds()).format("ss")
    //     let hourText = parseInt(hours) > 0 ? `${hours} hours` : " ";
    //     let minutesText = parseInt(minutes) > 0 ? `${minutes} minutes` : "";
    //     return `${hourText} ${minutesText} ${seconds} seconds`
    // }

    /**
     * 
     * @param date 
     * @returns 
     */
    const getDateLocal = (date: string) => {
        return formatDate(moment.utc(item.date), "", true)
    }

    const getDuration = (): number => {
        const recordingDuration = parseInt(`${meta.recordingDuration}`)
        return sanitizeNumeric(recordingDuration)
    }


    const recordingDuration = (recordingStartTime, recordingDuration: number) => {
        if (!moment(recordingStartTime).isValid()) {
            return "";
        }
        try {
            return moment(recordingStartTime).add(recordingDuration, "seconds").format("h:mm A")
        } catch (error) {
            return '';
        }
    }


    const startTime = () => {
        // if (meta.startTime && meta.startTime.date) {
        //     console.log("startTime->date ", meta.startTime.date)
        //     console.log("startTime->date ", moment.utc(meta.startTime.date))
        //     console.log("startTime->normal ", moment(moment.utc(meta.startTime.date)).format("MM/DD/YYYY h:mm:ss A"))
        //     console.log("startTime->local ", moment.utc(meta.startTime.date).local().format('MM/DD/YYYY h:mm:ss A'))
        // }
        return meta.startTime && meta.startTime.date && formatDate(meta.startTime.date, config.dateFormat.dateTime)
    }

    /**
     * 
     * @returns 
     */
    const isRecording = () => {
        if (meta.recordingStartTime == "" || meta.recordingDuration == "") {
            return false
        }
        return true;
    }
    /**
     * 
     * @returns 
     */
    const renderDateDuration = () => {
        if (!isRecording()) {
            return ""
        }
        return `${formatDate(moment.utc(item.date), config.dateFormat.dateTime, true)} to ${recordingDuration(getDateLocal(item.date), parseInt(`${meta.recordingDuration}`))}`
    }
    /**
     * 
     * @returns 
     */
    const renderAudioControls = () => {
        if (isRecording()) {
            return (<audio controls style={{ width: "100%" }} >
                <source type="audio/mp3" src={meta.recordingUrl} />
            </audio>)
        } else {
            return (<span className="text-danger">Call not picked up.</span>)
        }
    }


    const parseDisputeNotes = (): void => {
        try {

            let phoneAnnotations: Array<PhoneAnnotationT> = _.isArray(item?.disputeNotes) ? item?.disputeNotes : []
            setAnnotations(phoneAnnotations)
        }
        catch (err) {
            console.log(err)
        }
    }

    const addNewAnnotation = () => {
        let cloneItems = _.cloneDeep(annotations)
        if (!_.isArray(cloneItems)) {
            cloneItems = []
        }
        let cloneItem = _.cloneDeep(PhoneAnnotationObject)
        cloneItem.startTime = 0
        cloneItem.endTime = getDuration()
        cloneItems.push(cloneItem)
        setAnnotations(cloneItems)
    }


    const updateLineItemAnnotation = (index: number, item: PhoneAnnotationT) => {
        let cloneItems = _.cloneDeep(annotations)
        cloneItems[index] = item
        setAnnotations(cloneItems)
    }

    /**
     * 
     * @param index 
     */
    const removeLineItemAnnotation = (index: number): void => {
        let _cloneItems = _.cloneDeep(annotations)
        const filteredItems = _cloneItems.slice(0, index).concat(_cloneItems.slice(index + 1, _cloneItems.length))
        // console.log("filteredItems", filteredItems)
        setAnnotations(filteredItems)
    }


    const saveAnnotations = async (disputeNotes: Array<PhoneAnnotationT>): Promise<string> => {
        let params = {
            "disputeNotes": disputeNotes
        }
        return await AxiosInstance.post(`${config.url.jobs}/${job.id}/communications/${item?.id}/dispute_annotations`, params).then((res) => {
            return 'Notes saved.'
        })
    }


    return (
        <div className={` ${item.direction == "outgoing" ? css(styles.itemContact, styles.right) : styles.itemContact}`} >
            <div className="contact-header">
                <span className="title"> <IosCallOutline />  <strong className="display-name">{item.sender.firstName} {item.sender.lastName}</strong>
                    &nbsp;&nbsp;
                    <span className="date">{renderDateDuration()} </span>

                </span>

                {(job.closedIn.communicationId == item.id && job.jobStatus == JobStatusT.scheduled) && <span className="closed-in"> <IosCashOutline color='green' />  Closed in <strong style={{ color: 'green' }}> {durationToDDHHMMSSMS(job.closedIn.time)}</strong></span>}

            </div>

            <div className="contact-body">
                {isReady && renderAudioControls()}
                <br /><br />
                {meta.transcriptionText != "" && <> <h4>Transcription</h4>
                    <div>
                        <p>{meta.transcriptionText} </p>
                    </div>
                </>}
            </div>

            {(disputeEdit) &&
                <>
                    {annotations && annotations.map((item: PhoneAnnotationT, index: number): JSX.Element => {
                        return <AnnotationPhone
                            duration={getDuration()}
                            item={item}
                            index={index}
                            key={`Annotation-${index}`}
                            annotationType='dispute'
                            updateLineItem={updateLineItemAnnotation}
                            removeLineItem={removeLineItemAnnotation}
                        />
                    })}
                    {displayMode == "edit" && <Container className='mt-2 d-flex flex-column' >
                        <Stack spacing={2}>
                            <Button
                                onClick={() => {
                                    addNewAnnotation()
                                }}
                                style={{
                                    width: "20%"
                                }}
                                color='info'
                                variant='contained' >
                                <i className='fa fa-plus' />&nbsp;  Add Notes
                            </Button>
                            <ButtonLoading
                                customButton={Button}
                                // fullWidth
                                style={{
                                    width: "20%"
                                }}
                                customButtonProps={{
                                    color: "success",
                                    variant: "contained"
                                }}
                                onClickFetching={async (): Promise<string> => {
                                    return await saveAnnotations(annotations)
                                }} >
                                <i className='fa fa-plus' />&nbsp;Save Notes
                            </ButtonLoading>
                        </Stack>
                    </Container>}
                </>
            }

        </div>
    );
}
export default ContactPhone;
export { ContactPhone };